import React, { useContext, useEffect } from "react";
import { TableDataContext } from "../../../Contexts/TableDataContext";
import AnnouncedValueM from "./AnnouncedValueM";
import AnnouncedValueCr from "./AnnouncedValueCr";
import Acquisitions from "./Acquisitions";
import MostActiveAcquirers from "./MostActiveAcquirers";
import { Tooltip } from "antd";
import { useLocation, useNavigate } from "react-router";
import { routeNames } from "../../../routeSegments";
import { PeFilterContext } from "../../../Contexts/PeFilterContext";
import NoOfAquestions from "./NoOfAquestions";
import TotalAquestions from "./TotalAquestions";

/**
 * The `Card` component renders four cards with different data based on the `data`, `isLoad`, and
 * `isDataLoad` values from the `TableDataContext`.
 * @returns The Card component is returning a JSX element.
 */
const Card = ({menu}) => {
  const { data, isLoad, isDataLoad } = useContext(TableDataContext);
  const { monthPickerValue } = useContext(PeFilterContext);

  useEffect(() => {}, [data, isLoad, isDataLoad]);
  const location = useLocation();

  const handleOpenNewTab = () => {
    if(data.most_active_acquirers == 0){
      return
    }
    if (!monthPickerValue || monthPickerValue.length !== 2) return;
    const query = new URLSearchParams({
      fromDate: monthPickerValue[0],
      toDate: monthPickerValue[1],
      prePath: location.pathname,
    }).toString();
    const newTabUrl = `${window.location.origin}${routeNames.MA_most_active_acquirers}?${query}`;
    window.open(newTabUrl, "_blank", "noopener,noreferrer");
  };
  console.log(data, "acq data")

  return (
    <div className="">
      <div className="sm:full md:mt-[3rem] mt-[4.25rem] h-full bg-[#F2F2F2]">
        <div className="hidden md:block md:overflow-x-auto lg:grid lg:grid-cols-4 lg:gap-4 lg:px-4 lg:py-[0.7rem] lg:overflow-hidden scrollbar-remove" style={{scrollbarWidth: 'none'}}>
          <div className="md:grid md:grid-cols-4 md:gap-4 md:px-4 md:py-[0.7rem] md:min-w-max lg:contents">
            {/* ----card1----- */}
            <AnnouncedValueM
            data={data}
            isLoad={isLoad}
            isDataLoad={isDataLoad}
          />
          {/* ----card2----- */}
          <AnnouncedValueCr
            data={data}
            isLoad={isLoad}
            isDataLoad={isDataLoad}
          />
          {/* ----card3----- */}
          {menu !== "ma" ? (
            <>
              <Acquisitions
                data={data}
                isLoad={isLoad}
                isDataLoad={isDataLoad}
              />
              <Tooltip title="Acquirer who has made more than 1 acquisition in the chosen period">
                <span
                  onClick={handleOpenNewTab}
                  className="cursor-pointer flex-shrink-0"
                >
                  <MostActiveAcquirers
                    data={data}
                    isLoad={isLoad}
                    isDataLoad={isDataLoad}
                  />
                </span>
              </Tooltip>
            </>
          ) : (
            <>
              <NoOfAquestions
                data={data}
                isLoad={isLoad}
                isDataLoad={isDataLoad}
              />
              {/* ----card4----- */}
              <TotalAquestions
                data={data}
                isLoad={isLoad}
                isDataLoad={isDataLoad}
              />
            </>
          )}
          </div>
        </div>
        <div className="border-b-2 border-[#e5e5e5]"></div>
      </div>
    </div>
  );
};
export default Card;
